import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NvButtonModule } from '../../../../nvps-libraries/design/nv-button/nv-button.module';
import { NvDatePickerModule } from '../../../../nvps-libraries/design/nv-date-picker/nv-date-picker.module';
import { NvDropdownModule } from '../../../../nvps-libraries/design/nv-dropdown/nv-dropdown.module';
import { NvIconButtonModule } from '../../../../nvps-libraries/design/nv-icon-button/nv-icon-button.module';
import { NvIconModule } from '../../../../nvps-libraries/design/nv-icon/nv-icon.module';
import { NvNoteModule } from '../../../../nvps-libraries/design/nv-note/nv-note.module';
import { NvTextboxModule } from '../../../../nvps-libraries/design/nv-textbox/nv-textbox.module';
import { ExitViewModule } from '../../../shared/components/exit-view/exit-view.component.module';
import { PageHeaderModule } from '../../../shared/components/header/page-header/page-header.module';
import { ModalsModule } from '../../../shared/modals/modals.module';
import { AssessmentsDataInputBodyComponent } from './assessments-data-input/assessments-data-input-body/assessments-data-input-body.component';
import { AssessmentsDataInputHeaderComponent } from './assessments-data-input/assessments-data-input-header/assessments-data-input-header.component';
import { AssessmentsDataInputComponent } from './assessments-data-input/assessments-data-input.component';
import { AssessmentsDataInputService } from './assessments-data-input/assessments-data-input.service';
import { RowEditedDirective } from './assessments-data-input/row-edited.directive';
import { AssessmentsDataMidLevelComponent } from './assessments-mid-level/assessments-data-mid-level.component';

@NgModule({
  imports: [
    CommonModule,
    PageHeaderModule,
    ExitViewModule,
    ModalsModule,
    ScrollingModule,
    NvNoteModule,
    NvIconModule,
    NvButtonModule,
    NvIconButtonModule,
    NvDropdownModule,
    NvDatePickerModule,
    NvTextboxModule,
  ],
  declarations: [
    AssessmentsDataMidLevelComponent,
    AssessmentsDataInputComponent,
    AssessmentsDataInputHeaderComponent,
    RowEditedDirective,
    AssessmentsDataInputBodyComponent,
  ],
  exports: [
    AssessmentsDataMidLevelComponent,
    AssessmentsDataInputComponent,
    AssessmentsDataInputHeaderComponent,
    RowEditedDirective,
    AssessmentsDataInputBodyComponent,
  ],
  providers: [AssessmentsDataInputService, ScrollingModule, CdkVirtualScrollViewport],
})
export class AssessmentsDataEntryModule {}
